import { styled } from "styled-components";

import { UIIconButton } from "common/components";
import { breakpoints } from "common/styles";
import { useGo } from "common/utilities/useGo";
import { useTranslate } from "common/utilities/useTranslate";
import { CreateLandingTitle } from "domains/create/landing/CreateLandingTitle";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1500px;
  padding: 5rem 3rem 4rem;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media ${breakpoints.medium} {
    flex-direction: row;
  }
`;

export const CreateNewCollectionSection = () => {
  const go = useGo();
  const translate = useTranslate();

  const onClick = () => go("/collection");

  return (
    <StyledContainer>
      <CreateLandingTitle mode="collection" />
      <StyledButtonContainer>
        <UIIconButton icon="rightArrow" onClick={onClick} variant="filled">
          {translate("app.create.collection.landing_banner.button")}
        </UIIconButton>
      </StyledButtonContainer>
    </StyledContainer>
  );
};
